import { Component, Event, EventEmitter, forceUpdate, h, Host, Listen, Prop, State } from '@stencil/core';
import { WegweiserCategory } from './mama-wegweiser';

@Component({
  tag: 'mama-wegweiser-filters',
})
export class MamaWegweiserFilters {
  @Prop() category: WegweiserCategory = null;

  @Event() filterByCategoriesEvent: EventEmitter<number[]>;

  @State() activeFilters = [];
  @State() showFilters: boolean = true;

  @Listen('facilityResetFiltersEvent', { target: 'window' })
  onResetFilters() {
    this.reset();
  }

  addToFilter(uid) {
    this.activeFilters.push(uid);
    this.filterByCategoriesEvent.emit(this.activeFilters);
    forceUpdate(this);
  }

  removeFromFilter(uid) {
    this.activeFilters = this.activeFilters.filter(filter => filter !== uid);
    this.filterByCategoriesEvent.emit(this.activeFilters);
    forceUpdate(this);
  }

  toggleFilter(uid) {
    if (this.activeFilters.indexOf(uid) > -1) {
      this.removeFromFilter(uid);
    } else {
      this.addToFilter(uid);
    }
  }

  reset() {
    this.activeFilters = [];
    this.filterByCategoriesEvent.emit([]);
  }

  render() {
    if (!this.showFilters) {
      return null;
    }
    return (
      <Host class="filters">
        <p>Filter {this.category.title}</p>
        {this.category.children.map(child => {
          let isActive = this.activeFilters.indexOf(child.uid) > -1;
          return (
            <button
              class={{
                btn: true,
                active: isActive,
              }}
              onClick={() => this.toggleFilter(child.uid)}
            >
              {child.title}
              {isActive ? (
                <svg class="icon">
                  <use xlinkHref="#times-light" />
                </svg>
              ) : null}
            </button>
          );
        })}
      </Host>
    );
  }
}
